module.exports = __webpack_public_path__ + "img/symbol_3.a923a4ab.png";